// Manage flow of all booker authorization screens here
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccountInfo from './AccountInfo';
import Authorize from './Authorize';
import SetupSuccess from './SetupSuccess';
import StaffLogin from './StaffLogin';

export default class ZenotiSetup extends Component {
  constructor() {
    super();

    this.state = {
      isAccountInfoSaved: false,
      isSetupComplete: false,
      isAuthorized: false,
      staffCredSaved:false,
    };

    this.handleBackAction = this.handleBackAction.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { softwares: prevSoftwares } = this.props;
    const { softwares: newSoftwares } = nextProps;
    const newState = {};

    console.log('prevSoftwares , newSoftwares', prevSoftwares, newSoftwares);
    // isSavingZenotiAccountInfo: false,
    // isZenotiAccountInfoSaveSuccess: true,
    // isZenotiAccountInfoSaveFail: false,
    // if (prevSoftwares.isZenotiAccountInfoSaveSuccess) {
    //   newState.isAccountInfoSaved = true;
    // }

    if (
      prevSoftwares.isSavingZenotiAccountInfo &&
      !newSoftwares.isSavingZenotiAccountInfo &&
      newSoftwares.isZenotiAccountInfoSaveSuccess
    ) {
      newState.isAccountInfoSaved = true;
    }

    if (
      !prevSoftwares.isZenotiAutorized &&
       newSoftwares.isZenotiAutorized
    ) {
      newState.isAuthorized = true;
      newState.isAccountInfoSaved = false;
    }

    if (prevSoftwares.isZenotiAutorization && !newSoftwares.isZenotiAutorization) {
      newState.isSetupComplete = true;
    }
    console.log('prevSoftwares',prevSoftwares);
    console.log('newSoftwares',newSoftwares);
    if(!prevSoftwares.zenotiStaffCredLogin && newSoftwares.zenotiStaffCredLogin){
      newState.staffCredSaved = true
    }
    if (Object.keys(newState).length) {
      this.setState(newState);
    }
  }

  handleBackAction(screen) {
    if (screen === 'authorize') {
      this.setState({
        isAccountInfoSaved: false,
      });
    }
  }

  render() {
    const { router } = this.props;
    const { isAccountInfoSaved, isSetupComplete, isAuthorized ,staffCredSaved} = this.state;
    console.log("state",this.state);
    if (isSetupComplete) {
      // Show setup success screen
      return (
        <SetupSuccess
          onDone={() => {
            // Get Bookings Software Info
            this.props.getBookingSoftware();

            // Redirect to summary screen
            router.push('/app/setup');
          }}
          {...this.props}
        />
      );
    }

    if (staffCredSaved) {
      // Show Staff Add screen
      return (
        <Authorize
          onBack={() => {
            this.handleBackAction('authorize');
          }}
          {...this.props}
        />
      );
    }

    if (isAccountInfoSaved) {
      return (
        <StaffLogin
          onBack={() => {
            this.handleBackAction('authorize');
          }}
          {...this.props}
        />
      );
    }
    return <AccountInfo {...this.props} />;
  }
}

ZenotiSetup.propTypes = {
  getBookingSoftware: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
  router: PropTypes.shape().isRequired,
};
